import React from 'react';
import './App.css';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import ProblemSolution from './components/ProblemSolution';
import Features from './components/Features';
import HowItWorks from './components/HowItWorks';
import Builders from './components/Builders';
import HotOffers from './components/HotOffers';
import AdBanner from './components/AdBanner';
import AppScreenshots from './components/AppScreenshots';
import FAQ from './components/FAQ';
import Reviews from './components/Reviews';
import Download from './components/Download';
import Footer from './components/Footer';

function App() {
  return (
    <div className="App">
      <Navbar />
      <Hero />
      <ProblemSolution />
      <Features />
      <AppScreenshots />
      <HowItWorks />
      <HotOffers />
      <Builders />
      <AdBanner />
      <FAQ />
      <Reviews />
      <Download />
      <Footer />
    </div>
  );
}

export default App;
